export default __webpack_public_path__ + "static/media/logo.fa04b9b7.svg";